export const ASB_RESUME_ERROR = 'resumeAuthJourney failure';

export const trace = (...params: any[]) => {
  const enableTraceOverrideOnApp =
    (process.env.REACT_APP_AUTHENTICATED_TRACE ?? '').toLowerCase() === 'enabled' && process.env.REACT_APP_STAGE !== 'production';
  if (enableTraceOverrideOnApp) {
    console.log(...params); // eslint-disable-line no-console
  }
};

/**
 * Temp logger, so we can get to the bottom of login issue
 */
export const logger = {
  log: (message: string) => {
    console.log(`FALCON LOG: ${message}`);
  }
};
